import { useTranslation } from 'react-i18next'
import { useQueryParams } from 'use-query-params'

import { ReactComponent as Refresh } from '../../../../../assets/icons/refresh.svg'
import { Mode } from '../../../../../types/mode'
import { isMode } from '../../../../../utils/isMode'
import { ConversationsFiltersCategoriesEnum } from '../ConversationsFilters'

import { joinClassNames } from '../../../../../utils/styles'
import styles from './conversations-filters-menu.module.scss'

interface IConversationFiltersMenu {
    category: ConversationsFiltersCategoriesEnum
    setCategory: React.Dispatch<
        React.SetStateAction<ConversationsFiltersCategoriesEnum>
    >
}

function ConversationsFiltersMenu(props: IConversationFiltersMenu) {
    const { category, setCategory } = props

    const { t } = useTranslation()

    const [, setQuery] = useQueryParams()

    return (
        <div className={styles.conversationsFiltersMenu}>
            <div>
                {Object.keys(ConversationsFiltersCategoriesEnum).map((key) => {
                    const conversationsFilterKey =
                        key as keyof typeof ConversationsFiltersCategoriesEnum

                    const conversationsCategory =
                        ConversationsFiltersCategoriesEnum[
                            conversationsFilterKey
                        ]

                    const hideFilters =
                        isMode(Mode.BASIC) &&
                        (conversationsCategory ===
                            ConversationsFiltersCategoriesEnum.ENTITIES ||
                            conversationsCategory ===
                                ConversationsFiltersCategoriesEnum.ACTIONS)

                    if (hideFilters) {
                        return null
                    }

                    return (
                        <button
                            className={joinClassNames(
                                styles.conversationsFiltersMenu__btn,
                                category === conversationsCategory &&
                                    styles.conversationsFiltersMenu__btnActive
                            )}
                            onClick={() => setCategory(conversationsCategory)}
                            key={key}
                        >
                            {t(conversationsCategory)}
                        </button>
                    )
                })}
            </div>
            <button
                onClick={() => setQuery({}, 'replace')}
                className={styles.conversationsFiltersMenu__clearBtn}
            >
                <Refresh
                    className={styles.conversationsFiltersMenu__clearBtnIcon}
                />
            </button>
        </div>
    )
}

export default ConversationsFiltersMenu
